module.exports = __webpack_public_path__ + "static/media/attendee_host.f9b8aa22.svg";